// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_CreateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /odoo_tickets/create
 *
 * Success: returns ticket_id and confirmation message
 * Error: handled via sendError(), this contract is for success path only
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OdooTickets_CreateResponseDados {
ticket_id?: number
message?: string
}

export type OdooTickets_CreateResponse = ApiResponse<OdooTickets_CreateResponseDados>;

registerResponseContract('OdooTickets_CreateResponse', {
  ticket_id: { type: 'number',  required: false },
  message:   { type: 'string',  required: false },
})
